/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as API from "../../http/api";
import * as DATA from "../elements";
import DataTable from "react-data-table-component";
import Checkbox from "@mui/material/Checkbox";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import moment from "moment";
import "moment/locale/es";

const LogisticList = (props) => {
  moment.locale("es");
  const history = useHistory();
  const [tabActive, setTabActive] = useState("");
  const [list, setList] = useState([]);
  const [listSend, listSendState] = React.useState({});
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(50);
  const [disabled, setDisabled] = useState(true);
  const [printType, setPrintType] = useState("cards");
  const [clear, setClear] = useState(false);
  const [tabs] = useState([
    { status: "assigned", title: "Asignadas" },
    { status: "send", title: "Creadas" },
    { status: "finished", title: "Impresas" },
    { status: "error", title: "Error" },
  ]);

  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setTabActive(props.content.status);
    setList(props.content.cards);
    setTotal(props.content.total);
    setLimit(props.content.limit);
    setPrintType(props.content.type);
    if (props.content.type == "files") {
      let list = props.content.cards;
      order(list);
      setList(list);
    }
  };

  const changeTab = (tab) => {    
    setTabActive(tab);
    let data = {
      page: 1,
      limit: 50,
      status: tab,
      type: tab == "finished" ? "files" : "cards",
    };
    setList([]);
    setTabActive(tab);
    requestStatus(data);
    selected({allSelected: false,
      selectedCount: 0,
      selectedRows: [],
    })

    
  };

  const requestStatus = async (data) => {
    props.changeLoader(true);

    let widgetsLogistic = await API.service( "logisticList", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (widgetsLogistic.status == 200) {
      if (widgetsLogistic.data.data.response == "OK") {
        props.changeWidgets(widgetsLogistic.data.data.widget);
      }
    } else {
      props.changeWidgets([]);
    }
    props.changeLoader(false);
  };

  const requestCards = async (data) => {
    props.changeLoader(true);

    let request = await API.service( "logisticList", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  const sendGuides = async (list) => {
    props.changeLoader(true);

    let request = await API.service( "createGuides", list, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status === 200 && request.data.data.response === "OK") {
      let data = {
        page: 1,
        limit: limit,
        status: tabActive,
        type: "cards",
      };
      setDisabled(true);
      await requestCards(data);
    }
    props.changeLoader(false);
  };

  const printGuides = async (print) => {
    props.changeLoader(true);

    let listPrint = [];
    list.map((item ) => {
      print.map((p) => {
        if (item._id === p) {
          listPrint.push({
            uuid: item["uuid"],
            address: item["address"],
            url: item["url"],
            printName: item["customer"]["printName"],
            phone: item["customer"]["phone"],
            email: item["customer"]["email"],
          });
        }
      })
    })


    let request = await API.service( "printGuides", listPrint, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status === 200 && request.data.data.response === "OK") {
      let data = {
        page: 1,
        limit: limit,
        status: tabActive,
        type: printType,
      };
      props.changeAlert(true, "success", request.data.data.message);
      setDisabled(true);
      await requestCards(data);
    }
    props.changeLoader(false);
  };

  const downloadFile = async (path) => {
    props.changeLoader(true);

    let request = await API.service( "downloadFile", path, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      window.open(request.data.data.content, "Download");
    }
    props.changeLoader(false);
  };

  const order = (list) => {
    list.sort((a, b) => {
      return new Date(b.cdate).getTime() - new Date(a.cdate).getTime();
    });
  };

  const clickOpenEmail = (item) => {
    let request = item.customer.uuid;
    localStorage.setItem("valueSearch", item.customer.email);
    props.addWidget( "infoPersonal", request, ["changeEmail"],item.customer.email);
  };

  const columns = [
    { selector: (row) => row.customer.name, name: "Nombre", width: "27%", sortable: true},
    { selector: (row) => row.customer.email, name: "Email", width: "27%", sortable: true},
    { selector: (row) => row.statusParse, name: "Estatus", width: "10%", sortable: true},
    { selector: (row) => moment(row.udate).format("LLL"), name: "Fecha de Asignación", width: "25%", sortable: true},
    { cell: (row) => {
        return (
          <a href="#" data-tag="allowRowEvents" onClick={clickOpenEmail.bind(this, row)}><VisibilityIcon /></a>
        );
      },
      width: "50px", sortable: true,
    },
  ];

  const columnsPrinted = [
    { selector: (row) => row.uuid_file, name: "Nombre", width: "22%", wrap: true, sortable: true },
    { cell: (row) => {
        let file = row.files.guides.split("/")[row.files.guides.split("/").length - 1];
        return <a href="#" className="tap" onClick={downloadFile.bind(this, row.files.guides)}>{file}</a>
      },
      name: "Guía", width: "25%", wrap: true, sortable: true },
    { cell: (row) => {
        let file = row.files.labels.split("/")[row.files.labels.split("/").length - 1]
        return <a href="#" className="tap" onClick={downloadFile.bind(this, row.files.labels)}>{file}</a>
      },
      name: "Etiqueta", width: "25%", wrap: true, sortable: true },
    { cell: (row) => {
        let file = row.files.zebra.split("/")[row.files.zebra.split("/").length - 1]
        return <a href="#" className="tap" onClick={downloadFile.bind(this, row.files.zebra)}>{file}</a>
      },
      name: "Zebra", width: "25%", wrap: true, sortable: true }
  ];

  const showInfo = (item) => {
    return (
      <div className="select_info">
        <DATA.InfoDoc content={item} />
      </div>
    );
  };

  const selected = (data) => {
    if (data.selectedCount > 0) {
      const s = [];
      for (let i = 0; i < data.selectedRows.length; i++) {
        s.push(data.selectedRows[i].uuid);
      }
      listSendState(s);
      setDisabled(false);
    } else {
      setClear(true)
      setTimeout(() => {setClear(false)}, 1000);
      setDisabled(true);
    }
  };

  return (
    <div className="size-12">
      <div className="card">
        <div className="size-12 tabBox">
          <ul>
            {tabs.map((item, index) => {
              return (
                <li
                  key={`amin-tabs-${index}`}
                  className={tabActive === item.status ? "active" : ""}
                  onClick={changeTab.bind(this, item.status)}
                >{item.title}</li>
              );
            })}
          </ul>
        </div>

        <div className="size-12">
          <div className="form-row">
            <i className="ibon-card inb4" style={{ marginRight: "4px" }} />
            <h3 className="col-9 fix-elm-title-widget pnl-per-env-tarj">
              {tabActive === "assigned" ? "Personalización y envío de tarjetas"
                : tabActive === "send" ? "Tarjetas para imprimir"
                : tabActive === "finished" && printType == "cards" ? "Tarjetas impresas"
                : tabActive === "finished" && printType == "files" ? "Archivos"
                : "Tarjetas en error"}
            </h3>
            {tabActive !== "finished" && tabActive !== "error" && (
              <div className={disabled ? `col-2 pnl-per-env-trj-btn disable bigButton desktop` : `col-2 pnl-per-env-trj-btn bigButton desktop`}>
                {tabActive === "assigned" && (
                  <button onClick={() => sendGuides(listSend)}>Enviar</button>
                )}
                {tabActive === "send" && (
                  <button onClick={() => printGuides(listSend)}>Imprimir</button>
                )}
              </div>
            )}
          </div>

          <div className="form-row pnl-ltr-per-env">
            <div className="col-7">
              {tabActive === "assigned" && printType == "cards" && (
                <p>
                  Te han sido asignadas <span>{total}</span> tarjeta(s). Al enviar
                  quedará registrada la solicitud con la mensajería y se
                  generarán los archivos para su impresión.
                </p>
              )}
              {tabActive === "send" && printType == "cards" && (
                <p>Tienes <span>{total}</span> tarjeta(s) para imprimir</p>
              )}
              {tabActive === "finished" && printType == "cards" && (
                <p>Tienes <span>{total}</span> tarjeta(s) impresas</p>
              )}
              {tabActive === "finished" && printType == "files" && (
                <p>Tienes <span>{total}</span> documento(s)</p>
              )}
              {tabActive === "error" && printType == "cards" && (
                <p>Tienes <span>{total}</span> tarjeta(s) en error</p>
              )}
            </div>
          </div>
        </div>

        <div style={{ width: "100%", margin: "auto" }}>
          <ThemeProvider theme={theme}>
            <DataTable
              columns={tabActive === "finished" ? columnsPrinted : columns}
              data={list}
              customStyles={customStyles2}
              selectableRows={tabActive === "finished" || tabActive === "error" ? false : true}
              selectableRowsComponent={Checkbox}
              onSelectedRowsChange={selected}
              clearSelectedRows={clear}
              expandableRows={tabActive === "finished" && printType == "files" ? true : false}
              expandOnRowClicked={false}
              expandableRowsComponent={showInfo}
              noDataComponent={noDataComponent}
              // selectableRowSelected={(row) => {return false}}
            />
          </ThemeProvider>
        </div>
      </div>
    </div>
  );
};

export default LogisticList;
